import { RlControl } from "../shared/rl-control";

export class VisibleDateRange extends RlControl {
    start : Date | '';
    end : Date | '';
    isVisibleBetweenDates : boolean;
}